module.exports = __webpack_public_path__ + "img/MG-title.9a97c482.png";